module.exports = __webpack_public_path__ + "img/ellips_big_orange.d0538c51.png";